import { LabelProps } from "recharts";

export const DEFAULT_X_AXIS_LABEL: LabelProps = {
  position: "insideBottom",
  angle: 0,
  offset: -10,
  fill: "#8a8c8c",
};
